export enum GalenErrorKeys {
  SERVER_ERROR = 'server-error',
  UNKNOWN_ERROR = 'unknown-error',

  USER_DOES_NOT_EXIST = 'user-does-not-exists',
  EMAIL_OR_PASSWORD_INCORRECT = 'email-address-or-password-incorrect',
  USER_NOT_FOUND = 'user-not-found',
  USER_NOT_ACTIVE = 'user-not-active',
  USER_IS_LOCKED_OUT = 'user-is-locked-out',

  PASSWORD_IS_REQUIRED = 'password-is-required',
  NEW_PASSWORD_IS_REQUIRED = 'new-password-is-required',
  NEW_CONFIRM_PASSWORD_IS_REQUIRED = 'new-confirm-password-is-required',
  PASSWORDS_DO_NOT_MATCH = 'password-and-confirm-passwords-do-not-match',
  PASSWORD_NOT_LONG_ENOUGH = 'password-not-long-enough',
  PASSWORD_NOT_ENOUGH_UPPERCASE = 'password-not-enough-uppercase-letters',
  PASSWORD_NOT_ENOUGH_LOWERCASE = 'password-not-enough-lowercase-letters',
  PASSWORD_NOT_ENOUGH_NUMBERS = 'password-not-enough-numbers',
  PASSWORD_NOT_ENOUGH_SPECIAL_CHARACTERS = 'password-not-enough-special-characters',
  PASSWORD_CONTAINS_UNSUPPORTED_CHARACTERS = 'password-contains-unsupported-characters',
  PASSWORD_WAS_REUSED = 'password-was-reused-previously',

  NOT_AUTHORIZED = 'not-authorized',

  DEVICE_PROPERTY_SET_ID_REQUIRED = 'device-property-set-id-is-required',
  DEVICE_DATA_REQUIRED = 'device-data-is-required',
  DEVICE_DATA_MODEL_ID_REQUIRED = 'device-data-model-id-is-required',
  DEVICE_ID_REQUIRED = 'device-id-is-required',
  DEVICE_DATA_MAP_REQUIRED = 'device-data-map-is-required',
  DEVICE_NOT_FOUND = 'device-not-found',
  DEVICE_SET_NOT_ACCEPT_EXTERNAL_DATA = 'device-set-does-not-accept-data-from-external-source',
  COULD_NOT_SAVE_DEVICE_DATA = 'could-not-save-device-data',
  COULD_NOT_GET_DEVICE_DATA = 'could-not-get-device-data',
  FILE_SIZE_TOO_LARGE = 'file-size-too-large',
  DEVICE_MEDIA_REQUIRED = 'device-media-is-required',
  DEVICE_PROPERTY_NOT_FOUND = 'device-property-not-found',
  NOT_A_MEDIA_PROPERTY = 'not-a-media-property',
  DEVICE_DATA_NOT_FOUND = 'device-data-not-found',
  COULD_NOT_SAVE_DEVICE_MEDIA_DATA = 'could-not-save-device-data-media',
  COULD_NOT_GET_DEVICE_MEDIA_DATA = 'could-not-get-device-data-media',

  NONE_FOUND = 'none-found',

  PRACTICE_IS_REQUIRED = 'practice-is-required',
  PRACTICE_DOES_NOT_EXIST = 'practice-does-not-exist',
  PRACTICE_NOT_ACTIVE = 'practice-not-active',
  PRACTICE_ID_REQUIRED = 'practice-id-is-required',

  USER_ID_ALREADY_EXISTS = 'user-id-already-exists',
  USER_IS_REQUIRED = 'user-is-required',
  USER_ID_REQUIRED = 'user-id-is-required',

  USER_EMAIL_ALREADY_EXISTS = 'user-email-address-already-exists-for-this-tenant',
  COULD_NOT_UPDATE_USER_PROFILE = 'could-not-update-user-profile',
  CURRENT_PASSWORD_INCORRECT = 'current-password-is-incorrect',
  COULD_NOT_UPDATE_USER_PASSWORD = 'could-not-update-user-password',
  COULD_NOT_CREATE_USER = 'could-not-create-user',
  USER_ACCESS_NOT_ALLOWED = 'user-access-not-allowed-by-tenant',
  GUEST_ROLE_NOT_ALLOWED = 'guest-role-not-allowed-for-user-create',
  COULD_NOT_REGISTER_USER = 'could-not-register-user',
  COULD_NOT_ACTIVATE_USER = 'could-not-activate-user',
  COULD_NOT_SEND_OTP = 'could-not-send-otp-code',
  NOT_ALLOWED_TO_LOGIN = 'not-allowed-to-login-to-this-app',
  COULD_NOT_UPDATE_TERMS_AGREEMENT = 'could-not-update-user-terms-of-agreement-for-tenant',
  COULD_NOT_RESET_USER_AGREEMENT = 'could-not-reset-user-agreement-for-tenant-terms-of-use',
  CURRENT_ROLE_TARGET_ROLE_SAME = 'current-role-and-target-role-cannot-be-same',
  USER_CONTACT_INFO_NOT_FOUND = 'user-contact-info-not-found',
  USER_PRIMARY_PHONE_NOT_FOUND = 'user-primary-phone-not-found',

  CONTACT_LABEL_ALREADY_EXISTS = 'contact-label-already-exists-for-this-user',
  COULD_NOT_CREATE_USER_CONTACT = 'could-not-create-user-contact',
  COULD_NOT_UPDATE_USER_CONTACT = 'could-not-update-user-contact',
  COULD_NOT_DELETE_USER_CONTACT = 'could-not-delete-user-contact',

  LAYOUT_NAME_ALREADY_EXISTS_FOR_OWNER = 'layout-name-already-exists-for-owner',
  COULD_NOT_CREATE_LAYOUT = 'could-not-create-layout',
  LAYOUT_NOT_FOUND = 'layout-not-found',
  WIDGET_NOT_FOUND = 'widget-not-found',
  COULD_NOT_CREATE_LAYOUT_WIDGET = 'could-not-create-layout-widget',
  COULD_NOT_GET_LAYOUTS_FOR_USER = 'could-not-get-layouts-for-user',
  COULD_NOT_UPDATE_LAYOUT = 'could-not-update-layout',
  COULD_NOT_UPDATE_LAYOUT_WIDGET = 'could-not-update-layout-widget',
  LAYOUT_WIDGET_NOT_FOUND = 'layout-widget-not-found',
  COULD_NOT_DELETE_LAYOUT_WIDGET = 'could-not-delete-layout-widget',
  LAYOUT_WIDGET_USER_FILTER_IS_REQUIRED = 'layout-widget-user-filter-is-required',
  LAYOUT_NAME_IS_REQUIRED = 'layout-name-is-required',

  PRACTICE_ID_ALREADY_EXISTS = 'practice-id-already-exists',
  PRACTICE_NAME_IS_REQUIRED = 'practice-name-is-required',
  PRACTICE_NAME_ALREADY_EXISTS = 'practice-name-already-exists',
  COULD_NOT_CREATE_PRACTICE = 'could-not-create-practice',
  COULD_NOT_UPDATE_PRACTICE = 'could-not-update-practice',
  COULD_NOT_DELETE_PRACTICE = 'could-not-delete-practice',

  SUPPLIER_NOT_ENABLED_FOR_TENANT = 'supplier-not-enabled-for-tenant',
  SUPPLIER_IS_REQUIRED = 'supplier-is-required',
  SUPPLIER_NAME_IS_REQUIRED = 'supplier-name-is-required',
  SUPPLIER_ID_ALREADY_EXISTS = 'supplier-id-already-exists',
  SUPPLIER_NAME_ALREADY_EXISTS = 'supplier-name-already-exists',
  COULD_NOT_CREATE_SUPPLIER = 'could-not-create-supplier',
  SUPPLIER_NOT_FOUND = 'supplier-not-found',
  COULD_NOT_UPDATE_SUPPLIER = 'could-not-update-supplier',
  SUPPLIER_ID_IS_REQUIRED = 'supplier-id-is-required',
  COULD_NOT_GET_SUPPLIER_BY_ID = 'could-not-get-supplier-by-id',
  COULD_NOT_DELETE_SUPPLIER = 'could-not-delete-supplier',
  COULD_NOT_GET_ALL_SUPPLIERS_FOR_TENANT_AND_FILTERS = 'could-not-get-all-suppliers-for-tenant-and-filters',
  SUPPLIER_NOT_ACTIVE = 'supplier-not-active',

  ROLE_IS_REQUIRED = 'role-is-required',
  TENANT_IS_REQUIRED = 'tenant-is-required',
  FIRST_NAME_IS_REQUIRED = 'first-name-is-required',
  LAST_NAME_IS_REQUIRED = 'last-name-is-required',
  EMAIL_ADDRESS_IS_REQUIRED = 'email-address-is-required',
  STREET_ADDRESS1_IS_REQUIRED = 'street-address-1-is-required',
  CITY_IS_REQUIRED = 'city-is-required',
  STATE_IS_REQUIRED = 'state-is-required',
  COUNTRY_IS_REQUIRED = 'country-is-required',
  ZIPCODE_IS_REQUIRED = 'zipcode-is-required',
  PRIMARY_PHONE_IS_REQUIRED = 'primary-phone-is-required',
  ROLES_ARE_REQUIRED = 'roles-are-required',

  INVALID_OTP_CODE = 'invalid-otp-code',
  EXPIRED_OTP_CODE = 'expired-otp-code',
  ERROR_RESEND_CODE = 'error-resend-code',
  INVALID_CAPTCHA = 'invalid-captcha',

  COULD_NOT_GET_AUDIT_LOGS = 'could-not-get-audit-logs',
  AUDIT_CRITERIA_IS_REQUIRED = 'audit-criteria-is-required',

  TOKEN_EXPIRATION_IN_THE_PAST = 'token-expiration-in-the-past',
  TOKEN_ALREADY_EXISTS = 'token-already-exists',
  COULD_NOT_CREATE_APP_TOKEN = 'could-not-create-app-token',
  COULD_NOT_GET_APP_TOKENS = 'could-not-get-app-tokens',
  COULD_NOT_CREATE_MASTER_TOKEN = 'could-not-create-master-token',
  COULD_NOT_UPDATE_MASTER_TOKEN_STATUS = 'could-not-update-master-token-status',
  COULD_NOT_GET_MASTER_TOKENS = 'could-not-get-master-tokens',
  COULD_NOT_GET_MASTER_TOKEN = 'could-not-get-master-token',

  USER_NOT_ALLOWED_TO_CREATE_OBSERVER = 'user-not-allowed-to-create-observer',
  OBSERVER_ACCESS_VALID_UNTIL_IN_PAST = 'observer-access-valid-until-in-past',
  COULD_NOT_CREATE_OBSERVER = 'could-not-create-observer',
  USER_NOT_PATIENT = 'user-not-patient',
  USER_OBSERVER_NOT_FOUND = 'user-observer-not-found',
  COULD_NOT_UPDATE_OBSERVER_STATUS = 'could-not-update-observer-status',
  OBSERVER_ALREADY_EXISTS = 'observer-already-exists',
  USER_OBSERVER_CANNOT_BE_SAME = 'user-observer-cannot-be-same',
  COULD_NOT_DELETE_USER_OBSERVER = 'could-not-delete-user-observer',
  COULD_NOT_UPDATE_USER_INVITE_STATUS = 'could-not-update-user-invite-status',
  COULD_NOT_GET_USER_OBSERVEES_FOR_DEVICE = 'could-not-get-user-observees-for-device',
  DATE_OF_BIRTH_CANNOT_BE_IN_THE_FUTURE = 'date-of-birth-cannot-be-in-the-future',
  USER_INVITE_ALREADY_EXISTS = 'user-invite-already-exists',

  COULD_NOT_GET_ALL_DEVICES_BY_FILTER = 'could-not-get-all-devices-by-filter',
  COULD_NOT_GET_ALL_DEVICES_BY_TENANT_FILTER_AND_ALLOWED_TO_SPECIFY_DATA = 'could-not-get-all-devices-by-tenant-filter-and-allowed-to-specify-data',

  TENANT_THEME_TEMPLATE_FILE_NOT_FOUND = 'tenant-theme-template-file-not-found',
  COULD_NOT_READ_TENANT_THEME_TEMPLATE_FILE = 'could-not-read-tenant-theme-template-file',
  TENANT_THEME_CONFIGURATION_IS_REQUIRED = 'tenant-theme-configuration-is-required',
  TENANT_THEME_CONFIGURATION_IS_INVALID = 'tenant-theme-configuraiton-is-invalid',
  COULD_NOT_SAVE_TENANT_THEME_CUSTOMISATION = 'could-not-save-tenant-theme-customisation',
  TENANT_PREFERENCE_VALUE_IS_REQUIRED = 'tenant-preference-value-is-required',
  TENANT_DOES_NOT_EXIST = 'tenant-does-not-exist',
  TENANT_NAME_ALREADY_EXISTS = 'tenant-name-already-exists',
  COULD_NOT_UPDATE_TENANT = 'could-not-update-tenant',
  TENANT_EMAIL_ADDRESS_IS_REQUIRED = 'tenant-emailaddress-is-required',
  COULD_NOT_UPDATE_TENANT_TERMS_OF_USE = 'could-not-update-tenant-terms-of-use',
  TENANT_ASSET_FILE_IS_REQUIRED = 'tenant-asset-file-is-required',
  COULD_NOT_SAVE_TENANT_ASSET_FILE = 'could-not-save-tenant-asset-file',
  COULD_NOT_GET_TENANT_ASSET_FILE = 'could-not-get-tenant-asset-file',
  TENANT_ASSET_FILE_IDENTIFIER_IS_REQUIRED = 'tenant-asset-file-identifier-is-required',
  COULD_NOT_SET_TENANT_LOGO_IMAGE = 'could-not-set-tenant-logo-image',
  UNABLE_TO_READ_TENANT_LOGO_FILE_FROM_REQUEST = 'unable-to-read-tenant-logo-file-from-request',
  TENANT_PREFERENCE_VALUE_IS_INVALID = 'tenant-preference-value-is-invalid',
  UNABLE_TO_PARSE_WEB_ACCESS_ROLES_PREFERENCE_VALUE = 'unable-to-parse-web-access-roles-preference-value',

  EVENT_DOES_NOT_SUPPORT_MULTIPLE_NOTIFICATIONS = 'event-does-not-support-multiple-notifications',
  EVENT_DOES_NOT_SUPPORT_NOTIFICATION_CHANNEL = 'event-does-not-support-notification-channel',
  COULD_NOT_GET_USER_EVENTS = 'could-not-get-user-events',
  EVENT_RULE_NAME_ALREADY_EXISTS = 'event-rule-name-already-exists',
  COULD_NOT_CREATE_USER_EVENT_RULE = 'could-not-create-user-event-rule',
  COULD_NOT_UPDATE_USER_EVENT_RULE = 'could-not-update-user-event-rule',
  COULD_NOT_DELETE_USER_EVENT_RULE = 'could-not-delete-user-event-rule',
  COULD_NOT_GET_USER_EVENT_RULE = 'could-not-get-user-event-rule',
  COULD_NOT_GET_USER_EVENT_RULES_FOR_USER_FILTER = 'could-not-get-user-event-rules-for-user-filter',

  FRESCA_PDF_REPORT_NOT_FOUND = 'fresca-pdf-report-not-found',
  FRESCA_COULD_NOT_GET_PDF_FROM_SERVER = 'fresca-could-not-get-pdf-from-server',

  DEVICE_PROPERTY_SET_NOT_FOUND = 'device-property-set-not-found',
  DEVICE_PROPERTY_CODE_IS_REQUIRED = 'device-property-code-is-required',
  DEVICE_PROPERTY_PREDEFINED_VALUES_REQUIRED = 'device-property-predefined-values-required',
  DEVICE_PROPERTY_PREDEFINED_VALUES_INVALID = 'device-property-predefined-values-invalid',

  COULD_NOT_DELETE_DEVICE_DATA_FOR_GIVEN_IDS_AND_FILTERS = 'could-not-delete-device-data-for-given-ids-and-filters',

  CUSTOM_FIELD_NAME_IS_REQUIRED = 'custom-field-name-is-required',
  CUSTOM_FIELD_TYPE_IS_REQUIRED = 'custom-field-type-is-required',
  CUSTOM_FIELD_OPTIONS_ARE_REQUIRED = 'custom-field-options-are-required',
  CUSTOM_FIELD_NAME_ALREADY_EXISTS = 'custom-field-name-already-exists',
  CUSTOM_FIELD_DOES_NOT_EXISTS = 'custom-field-does-not-exists',
  COULD_NOT_CREATE_CUSTOM_FIELD_FOR_USER_PROFILE = 'could-not-create-custom-field-for-user-profile',
  COULD_NOT_UPDATE_CUSTOM_FIELD_FOR_USER_PROFILE = 'could-not-update-custom-field-for-user-profile',
  COULD_NOT_DELETE_CUSTOM_FIELD_FOR_USER_PROFILE = 'could-not-delete-custom-field-for-user-profile',

  FILE_NAME_REQUIRED = 'file-name-required',
  MFA_MODE_REQUIRED = 'mfa-mode-required',
  COULD_NOT_SET_USER_MFA_MODE = 'could-not-set-user-mfa-mode',
  COULD_NOT_SET_USER_MFA_SETTING = 'could-not-set-user-mfa-setting',
  MFA_DISABLE_NOT_ALLOWED_BY_TENANT = 'mfa-disable-not-allowed-by-tenant',
  CANNOT_CHANGE_VERIFIED_PRIMARY_PHONE_WITH_SMS_MFA = 'cannot-change-verified-primary-phone-with-sms-mfa',
  USER_MFA_MODES_NOT_FOUND = 'user-mfa-modes-not-found',

  FIRMWARE_HASH_DO_NOT_MATCH = 'firmware-hash-do-not-match',
  FIRMWARE_NAME_ALREADY_EXISTS = 'firmware-name-already-exists',
  FIRMWARE_DISPLAY_VERSION_ALREADY_EXISTS = 'firmware-display-version-already-exists',
  COULD_NOT_CREATE_FIRMWARE = 'could-not-create-firmware',
  COULD_NOT_UPDATE_FIRMWARE = 'could-not-update-firmware',
  COULD_NOT_DELETE_FIRMWARE = 'could-not-delete-firmware',

  PHONE_NUMBER_REQUIRED = 'phone-number-required',
  COULD_NOT_SEND_PHONE_VERIFICATION_CODE = 'could-not-send-phone-verification-code',
  COULD_NOT_VERIFY_PHONE_VERIFICATION_CODE = 'could-not-verify-phone-verification-code',
  PHONE_NUMBER_NOT_SUPPORTED_FOR_VERIFICATION = 'phone-number-not-supported-for-verification',

  COULD_NOT_GET_EVENT_LOGS = 'could-not-get-event-logs',

  MTI_COULD_NOT_GET_REPORT_FROM_SERVER = 'mti-could-not-get-report-from-server',

  EXTERNAL_SERVICE_INFO_LABEL_ALREADY_EXISTS = 'external-service-info-label-already-exists',
  EXTERNAL_SERVICE_INFO_TYPE_ALREADY_EXISTS = 'external-service-info-type-already-exists',
  COULD_NOT_CREATE_EXTERNAL_SERVICE_INFO = 'could-not-create-external-service-info',
  COULD_NOT_UPDATE_EXTERNAL_SERVICE_INFO = 'could-not-update-external-service-info',
  COULD_NOT_GET_EXTERNAL_SERVICE_INFO = 'could-not-get-external-service-info',

  CUSTOM_DATA_VALUE_IS_REQUIRED = 'custom-data-value-is-required',
  CUSTOM_DATA_VALUE_IS_INVALID = 'custom-data-value-is-invalid',

  TOTP_VERIFICATION_ERROR = 'totp-verification-error',

  COULD_NOT_FIND_DEFAULT_EMAIL_TEMPLATES = 'could-not-find-default-email-templates',
  COULD_NOT_FIND_DEFAULT_EMAIL_TEMPLATE = 'could-not-find-default-email-template',
  COULD_NOT_FIND_CUSTOM_EMAIL_TEMPLATE = 'could-not-find-custom-email-template',
  COULD_NOT_FIND_CUSTOM_EMAIL_TEMPLATE_NAME = 'could-not-find-custom-email-template-name',
  COULD_NOT_FIND_EMAIL_TEMPLATES = 'could-not-find-email-templates',
  COULD_NOT_CREATE_EMAIL_TEMPLATE = 'could-not-create-email-template',
  COULD_NOT_UPDATE_EMAIL_TEMPLATE = 'could-not-update-email-template',
  COULD_NOT_DELETE_EMAIL_TEMPLATE = 'could-not-delete-email-template',
  COULD_NOT_FIND_EMAIL_TEMPLATE_PREFERENCES = 'could-not-find-email-template-preferences',
  COULD_NOT_UPDATE_EMAIL_TEMPLATE_PREFERENCES = 'could-not-update-email-template-preferences',
  COULD_NOT_DELETE_EMAIL_TEMPLATE_RELATED_DATA = 'could-not-delete-email-template-related-data',
  INVALID_EMAIL_TEMPLATE_PREFERENCES = 'invalid-email-template-preferences',
  EMAIL_TEMPLATE_NAME_ALREADY_EXISTS = 'email-template-name-already-exists',
  EMAIL_TEMPLATE_ID_IS_REQUIRED = 'email-template-id-is-required',
  EMAIL_TEMPLATE_PREFERENCE_MAP_IS_REQUIRED = 'email-template-preference-map-is-required',
  EMAIL_TEMPLATE_STYLES_FILE_NOT_FOUND = 'email-template-styles-file-not-found',
  EMAIL_TEMPLATE_FILE_NOT_FOUND = 'email-template-file-not-found',
  COULD_NOT_READ_EMAIL_TEMPLATE_FILE = 'could-not-read-email-template-file',
  COULD_NOT_BUILD_EMAIL_MESSAGE = 'could-not-build-email-message',
  EVENT_TYPE_IS_REQUIRED = 'event-type-is-required',
  COULD_NOT_BUILD_EMAIL_HEADER_FOOTER = 'could-not-build-email-header-footer',
  COULD_NOT_FIND_EMAIL_HEADER_FOOTER_TEMPLATE = 'could-not-find-email-header-footer-template',
  COULD_NOT_FIND_EMAIL_EVENT_IS_DISABLED = 'could-not-find-email-event-is-disabled',
  MULTIPLE_DEFAULT_EMAIL_TEMPLATES_FOUND = 'multiple-default-email-templates-found',

  COULD_NOT_FIND_DEVICE_DATA_FORMS = 'could-not-find-device-data-forms',
  COULD_NOT_FIND_DEVICE_DATA_FORM = 'could-not-find-device-data-form',
  DEVICE_DATA_FORM_ID_IS_REQUIRED = 'device-data-form-id-is-required',
  DEVICE_DATA_FORM_NAME_ALREADY_EXISTS = 'device-data-form-name-already-exists',
  COULD_NOT_FIND_DEVICE_DATA_FORM_NAME = 'could-not-find-device-data-form-name',
  COULD_NOT_CREATE_DEVICE_DATA_FORM = 'could-not-create-device-data-form',
  COULD_NOT_DELETE_DEVICE_DATA_FORM = 'could-not-delete-device-data-form',
  COULD_NOT_UPDATE_DEVICE_DATA_FORM = 'could-not-update-device-data-form',
  CONFIGURE_FIELDS_REQUIRED = 'configure-fields-required',
  FORM_CANNOT_SAVE_IN_PREVIEW_MODE = 'form-cannot-save-in-preview-mode',
  DEVICE_DATA_FORM_NOT_FOUND = 'device-data-form-not-found',
  DEVICE_DATA_FORM_IS_INACTIVE = 'device-data-form-is-inactive',
  DEVICE_DATA_FORM_DOES_NOT_SUPPORT_COLLECTION_METHOD = 'device-data-form-does-not-support-collection-method',
  DEVICE_DATA_FORM_DOES_NOT_SUPPORT_MODEL_SCOPE = 'device-data-form-does-not-support-model-scope',

  COULD_NOT_FIND_DEVICE_DATA_FORM_DRAFT_INSTANCES = 'could-not-find-device-data-form-draft-instances',
  COULD_NOT_FIND_DEVICE_DATA_FORM_COMPLETED_INSTANCES = 'could-not-find-device-data-form-completed-instances',
  COULD_NOT_FIND_ALL_DEVICE_DATA_FORM_INSTANCES = 'could-not-find-all-device-data-form-instances',
  COULD_NOT_FIND_DEVICE_DATA_FORM_INSTANCES_BY_IDS = 'could-not-find-device-data-form-instances-by-ids',
  COULD_NOT_FIND_DEVICE_DATA_FORM_INSTANCES = 'could-not-find-device-data-form-instances',
  COULD_NOT_FIND_DEVICE_DATA_FORM_INSTANCE = 'could-not-find-device-data-form-instance',
  COULD_NOT_CREATE_DEVICE_DATA_FORM_INSTANCE = 'could-not-create-device-data-form-instance',
  COULD_NOT_UPDATE_DEVICE_DATA_FORM_INSTANCE = 'could-not-update-device-data-form-instance',
  COULD_NOT_DELETE_DEVICE_DATA_FORM_INSTANCE = 'could-not-delete-device-data-form-instance',
  COULD_NOT_DELETE_DEVICE_DATA_FORM_DRAFT_INSTANCES = 'could-not-delete-device-data-form-draft-instances',
  COULD_NOT_SET_USER_TO_NULL_FOR_COMPLETED_INSTANCES = 'could-not-set-user-to-null-for-completed-instances',
  NOT_AUTHORIZED_TO_UPDATE_COMPLETED_DEVICE_DATA_FORM_INSTANCE = 'not-authorized-to-update-completed-device-data-form-instance',
  RESTRICTED_TO_CREATE_DEVICE_DATA_FORM_INSTANCE = 'restricted-to-create-device-data-form-instance',
  DATA_ENTER_BY_USER_NOT_FOUND = 'data-enter-by-user-not-found',
  OWNER_NOT_FOUND = 'owner-not-found',
  DEVICE_DATA_FORM_INSTANCE_NOT_FOUND = 'device-data-form-instance-not-found',
  DEVICE_DATA_FORM_INSTANCES_NOT_FOUND = 'device-data-form-instances-not-found',
  DEVICE_DATA_FORM_INSTANCE_IS_REQUIRED = 'device-data-form-instance-is-required',
  DEVICE_DATA_FORM_INSTANCE_ID_IS_REQUIRED = 'device-data-form-instance-id-is-required',
  DEVICE_DATA_NOT_COMPATIBLE_WITH_FORM = 'device-data-not-compatible-with-form',
  NOT_AUTHORIZED_TO_SAVE_FORM_FOR_SELECTED_OWNER = 'not-authorized-to-save-form-for-selected-owner',
  DEVICE_IS_INACTIVE = 'device-is-inactive',
  GROUPING_PROPERTY_VALUE_ALREADY_EXISTS_IN_ANOTHER_DEVICE_DATA = 'grouping-property-value-already-exists-in-another-device-data',

  TENANT_DOES_NOT_ALLOW_SELF_REGISTRATION = 'tenant-does-not-allow-self-registration',
  EXTERNAL_SERVICE_INFO_NOT_FOUND = 'external-service-info-not-found',
  LOGIN_TYPE_IS_NOT_SUPPORTED = 'login-type-is-not-supported',
  CODE_IS_REQUIRED = 'code-is-required',
  LOGIN_TYPE_IS_REQUIRED = 'login-type-is-required',
  REDIRECT_URI_IS_REQUIRED = 'redirect-uri-is-required',
  OAUTH2_SERVICE_TOKEN_NOT_FOUND = 'oauth2-service-token-not-found',
  OAUTH2_SERVICE_TOKEN_REQUEST_FAILED = 'oauth2-service-token-request-failed',
  ERROR_OCCURRED_WHILE_FETCHING_OAUTH2_TOKEN = 'error-occurred-while-fetching-oauth2-token',
  COULD_NOT_LOGIN_USER_USING_OAUTH2 = 'could-not-login-user-using-oauth2',
  COULD_NOT_REGISTER_USER_USING_OAUTH2 = 'could-not-register-user-using-oauth2',
  COULD_NOT_FIND_USER_TO_LOGIN_USING_OAUTH2 = 'could-not-find-user-to-login-using-oauth2',
  OAUTH2_SERVICE_API_UNABLE_TO_FIND_EMAIL_ADDRESS = 'oauth2-service-api-unable-to-find-email-address',
  OAUTH2_SERVICE_API_UNABLE_TO_FIND_FIRST_NAME = 'oauth2-service-api-unable-to-find-first-name',
  OAUTH2_SERVICE_API_UNABLE_TO_FIND_LAST_NAME = 'oauth2-service-api-unable-to-find-last-name',
  OAUTH2_CLIENT_SECRET_IS_REQUIRED = 'oauth2-client-secret-is-required',
  DEVICE_INSTANCE_IDENTIFIER_IS_REQUIRED = 'device-instance-identifier-is-required',
  DEVICE_INSTANCE_IDENTIFIER_ALREADY_EXISTS = 'device-instance-identifier-already-exists',
  MAX_ACTIVE_TOKEN_ALREADY_EXIST = 'max-active-token-already-exist',
  INVALID_MFA_AUTH_REQUEST = 'invalid-mfa-auth-request',
  EMAIL_ADDRESS_IS_INVALID = 'email-address-is-invalid',
  STATUS_IS_REQUIRED = 'status-is-required',

  EXTERNAL_SERVICE_OAUTH2_CLIENT_ID_IS_REQUIRED = 'external-service-oauth2-client-id-is-required',
  EXTERNAL_SERVICE_OAUTH2_CLIENT_SECRET_IS_REQUIRED = 'external-service-oauth2-client-secret-is-required',
  EXTERNAL_SERVICE_OAUTH2_CLIENT_DOMAIN_IS_REQUIRED = 'external-service-oauth2-client-domain-is-required',
  TENANT_ID_IS_REQUIRED = 'tenant-id-is-required',

  OTP_IS_REQUIRED = 'otp-is-required',
  OTP_TYPE_IS_REQUIRED = 'otp-type-is-required',
  CONTACT_INFO_IS_REQUIRED = 'contact-info-is-required',
  ERROR_DECODING_STRING_WITH_UTF8 = 'error-decoding-string-with-utf8',
  ONE_TIME_PASSWORD_IS_REQUIRED = 'one-time-password-is-required',
  INTERNAL_SERVER_ERROR = 'internal-server-error',
  COULD_NOT_CREATE_CSV_FILE = 'could-not-create-CSV-file',
  COULD_NOT_READ_CSV_FILE = 'could-not-read-csv-file',
  BAD_REQUEST = 'bad-request',
  METHOD_NOT_ALLOWED = 'method-not-allowed',
  MEDIA_TYPE_NOT_SUPPORTED = 'media-type-not-supported',

  TENANT_NOT_ACTIVE = 'tenant-not-active',
  TENANT_ID_ALREADY_EXISTS = 'tenant-id-already-exists',
  TENANT_NAME_IS_REQUIRED = 'tenant-name-is-required',
  TENANT_DOMAIN_NAME_IS_REQUIRED = 'tenant-domain-name-is-required',
  TENANT_DOMAIN_NAME_IS_INVALID = 'tenant-domain-name-is-invalid',
  TENANT_DOMAIN_NAME_ALREADY_EXISTS = 'tenant-domain-name-already-exists',
  TENANT_SUBSCRIPTION_LEVEL_IS_REQUIRED = 'tenant-subscription-level-is-required',
  TENANT_PREFERENCE_IS_INVALID = 'tenant-preference-is-invalid',
  NUMBER_OF_TENANT_PREFERENCES_EXCEEDS_MAX_ALLOWABLE = 'number-of-tenant-preferences-exceeds-max-allowable',
  COULD_NOT_CREATE_TENANT = 'could-not-create-tenant',
  COULD_NOT_DELETE_TENANT = 'could-not-delete-tenant',
  COULD_NOT_GET_TENANT_BY_ID = 'could-not-get-tenant-by-id',
  COULD_NOT_GET_TENANT_BY_NAME = 'could-not-get-tenant-by-name',
  COULD_NOT_GET_TENANT_BY_DOMAIN_NAME = 'could-not-get-tenant-by-domain-name',
  COULD_NOT_GET_ALL_TENANTS_BY_FILTER = 'could-not-get-all-tenants-by-filter',
  COULD_NOT_GET_TENANT_PREFERENCES = 'could-not-get-tenant-preferences',
  COULD_NOT_UPDATE_TENANT_PREFERENCES = 'could-not-update-tenant-preferences',

  COULD_NOT_GET_PRACTICE_BY_ID = 'could-not-get-practice-by-id',
  COULD_NOT_GET_ALL_PRACTICES_FOR_TENANT_AND_FILTERS = 'could-not-get-all-practices-for-tenant-and-filters',
  PRACTICE_NOT_LINKED_WITH_GIVEN_SUPPLIER = 'practice-not-linked-with-given-supplier',

  CURRENT_PASSWORD_IS_REQUIRED = 'current-password-is-required',
  APP_TYPE_IS_REQUIRED = 'app-type-is-required',
  TENANT_DOES_NOT_ALLOW_SELF_DELETION = 'tenant-does-not-allow-self-deletion',
  COULD_NOT_DELETE_USER = 'could-not-delete-user',
  COULD_NOT_UPDATE_USER_TERMS_OF_AGREEMENT = 'could-not-update-user-terms-of-agreement',
  COULD_NOT_GET_USER_BY_ID = 'could-not-get-user-by-id',
  COULD_NOT_GET_ALL_USERS_FOR_TENANT_AND_FILTERS = 'could-not-get-all-users-for-tenant-and-filters',
  COULD_NOT_GET_ALL_SYSTEM_ADMINS = 'could-not-get-all-system-admins',
  COULD_NOT_LOGIN_USER = 'could-not-login-user',
  COULD_NOT_UPDATE_USER_SUPPLIER = 'could-not-update-user-supplier',
  COULD_NOT_GET_USER_STATISTICS_FOR_TENANT = 'could-not-get-user-statistics-for-tenant',
  COULD_NOT_GET_USER_LOGIN_STATISTICS_FOR_TENANT = 'could-not-get-user-login-statistics-for-tenant',
  COULD_NOT_RESET_PASSWORD = 'could-not-reset-password',
  COULD_NOT_SWITCH_USER_ROLE = 'could-not-switch-user-role',
  USER_PRIMARY_PHONE_NOT_VERIFIED = 'user-primary-phone-not-verified',
  COULD_NOT_UNLOCK_USER = 'could-not-unlock-user',

  USER_CONTACT_IS_REQUIRED = 'user-contact-is-required',
  USER_CONTACT_ID_IS_REQUIRED = 'user-contact-id-is-required',
  USER_CONTACT_LABEL_IS_REQUIRED = 'user-contact-label-is-required',
  USER_CONTACT_ID_ALREADY_EXISTS = 'user-contact-id-already-exists',
  USER_CONTACT_NOT_FOUND = 'user-contact-not-found',
  COULD_NOT_GET_USER_CONTACT = 'could-not-get-user-contact',
  COULD_NOT_GET_ALL_USER_CONTACTS_FOR_USER = 'could-not-get-all-user-contacts-for-user',

  DEVICE_IS_REQUIRED = 'device-is-required',
  DEVICE_ID_ALREADY_EXISTS = 'device-id-already-exists',
  DEVICE_NAME_IS_REQUIRED = 'device-name-is-required',
  DEVICE_NAME_ALREADY_EXISTS = 'device-name-already-exists',
  COULD_NOT_CREATE_DEVICE = 'could-not-create-device',
  COULD_NOT_UPDATE_DEVICE = 'could-not-update-device',
  COULD_NOT_DELETE_DEVICE = 'could-not-delete-device',
  COULD_NOT_GET_DEVICE_BY_ID = 'could-not-get-device-by-id',

  DEVICE_DATA_MODEL_IS_REQUIRED = 'device-data-model-is-required',
  DEVICE_DATA_MODEL_NOT_FOUND = 'device-data-model-not-found',
  DEVICE_DATA_MODEL_ID_ALREADY_EXISTS = 'device-data-model-id-already-exists',
  DEVICE_DATA_MODEL_NAME_IS_REQUIRED = 'device-data-model-name-is-required',
  DEVICE_DATA_MODEL_NAME_ALREADY_EXISTS = 'device-data-model-name-already-exists',
  DEVICE_DATA_MODEL_IS_NOT_LINKABLE = 'device-data-model-is-not-linkable',
  COULD_NOT_CREATE_DEVICE_DATA_MODEL = 'could-not-create-device-data-model',
  COULD_NOT_UPDATE_DEVICE_DATA_MODEL = 'could-not-update-device-data-model',
  COULD_NOT_DELETE_DEVICE_DATA_MODEL = 'could-not-delete-device-data-model',
  COULD_NOT_GET_DEVICE_DATA_MODEL_BY_ID = 'could-not-get-device-data-model-by-id',
  COULD_NOT_GET_ALL_DEVICE_DATA_MODELS_BY_FILTER = 'could-not-get-all-device-data-models-by-filter',
  COULD_NOT_GET_ALL_DEVICE_DATA_MODELS_BY_TENANT_AND_FILTER = 'could-not-get-all-device-data-models-by-tenant-and-filter',
  COULD_NOT_GET_ALL_DEVICE_DATA_MODELS_BY_TENANT_FILTER_AND_ALLOWED_TO_SPECIFY_DATA = 'could-not-get-all-device-data-models-by-tenant-filter-and-allowed-to-specify-data',

  DEVICE_PROPERTY_SET_IS_REQUIRED = 'device-property-set-is-required',
  DEVICE_PROPERTY_SET_NOT_EMPTY = 'device-property-set-not-empty',
  DEVICE_PROPERTY_SET_ID_ALREADY_EXISTS = 'device-property-set-id-already-exists',
  DEVICE_PROPERTY_SET_NAME_IS_REQUIRED = 'device-property-set-name-is-required',
  DEVICE_PROPERTY_SET_NAME_ALREADY_EXISTS = 'device-property-set-name-already-exists',
  DEVICE_PROPERTY_SET_COLLECTION_METHOD_IS_REQUIRED = 'device-property-set-collection-method-is-required',
  DEVICE_PROPERTY_SET_ROLES_ALLOWED_TO_SPECIFY_IS_REQUIRED = 'device-property-set-roles-allowed-to-specify-is-required',
  DEVICE_PROPERTY_SET_PARSER_IS_REQUIRED = 'device-property-set-parser-is-required',
  DEVICE_PROPERTY_SET_PARSED_FROM_IS_REQUIRED = 'device-property-set-parsed-from-is-required',
  DEVICE_PROPERTY_SET_IS_NOT_COMPATIBLE = 'device-property-set-is-not-compatible',
  COULD_NOT_CREATE_DEVICE_PROPERTY_SET = 'could-not-create-device-property-set',
  COULD_NOT_UPDATE_DEVICE_PROPERTY_SET = 'could-not-update-device-property-set',
  COULD_NOT_DELETE_DEVICE_PROPERTY_SET = 'could-not-delete-device-property-set',
  COULD_NOT_GET_DEVICE_PROPERTY_SET_BY_ID = 'could-not-get-device-property-set-by-id',
  COULD_NOT_GET_ALL_DEVICE_PROPERTY_SETS_BY_FILTER = 'could-not-get-all-device-property-sets-by-filter',

  DEVICE_PROPERTY_IS_REQUIRED = 'device-property-is-required',
  DEVICE_PROPERTY_HAS_DATA = 'device-property-has-data',
  DEVICE_PROPERTY_IS_LINKED_TO_PATIENTS = 'device-property-is-linked-to-patients',
  DEVICE_PROPERTY_ID_IS_REQUIRED = 'device-property-id-is-required',
  DEVICE_PROPERTY_ID_ALREADY_EXISTS = 'device-property-id-already-exists',
  DEVICE_PROPERTY_NAME_IS_REQUIRED = 'device-property-name-is-required',
  DEVICE_PROPERTY_NAME_ALREADY_EXISTS = 'device-property-name-already-exists',
  DEVICE_PROPERTY_DATA_TYPE_IS_REQUIRED = 'device-property-data-type-is-required',
  DEVICE_PROPERTY_VALUE_TYPE_IS_REQUIRED = 'device-property-value-type-is-required',
  DEVICE_PROPERTY_VALUE_TYPE_IS_INVALID_FOR_DATA_TYPE = 'device-property-value-type-is-invalid-for-data-type',
  FORMULA_EXPRESSION_IS_REQUIRED = 'formula-expression-is-required',
  DEVICE_GROUPING_PROPERTY_ALREADY_EXISTS = 'device-grouping-property-already-exists',
  DEVICE_GROUPING_PROPERTY_DATA_TYPE_IS_INCORRECT = 'device-grouping-property-data-type-is-incorrect',
  COULD_NOT_CREATE_DEVICE_PROPERTY = 'could-not-create-device-property',
  COULD_NOT_UPDATE_DEVICE_PROPERTY = 'could-not-update-device-property',
  COULD_NOT_DELETE_DEVICE_PROPERTY = 'could-not-delete-device-property',
  COULD_NOT_GET_DEVICE_PROPERTY_BY_ID = 'could-not-get-device-property-by-id',
  COULD_NOT_GET_DEVICE_PROPERTY_BY_DEVICE_ID_AND_CODE = 'could-not-get-device-property-by-device-id-and-code',
  COULD_NOT_GET_ALL_DEVICE_PROPERTIES_BY_FILTER = 'could-not-get-all-device-properties-by-filter',
  COULD_NOT_UPDATE_DEVICE_PROPERTY_DISPLAY_ORDERS = 'could-not-update-device-property-display-orders',

  PATIENT_DEVICE_ID_IS_REQUIRED = 'patient-device-id-is-required',
  VALUE_IS_REQUIRED = 'value-is-required',
  DEVICE_PROPERTY_IS_NOT_LINKABLE = 'device-property-is-not-linkable',
  WRONG_USER_ROLE_FOR_LINKING = 'wrong-user-role-for-linking',
  PATIENT_DEVICE_LINK_ALREADY_EXISTS = 'patient-device-link-already-exists',
  PATIENT_DEVICE_LINK_NOT_FOUND = 'patient-device-link-not-found',
  COULD_NOT_LINK_PATIENT_TO_DEVICE = 'could-not-link-patient-to-device',
  COULD_NOT_UPDATE_PATIENT_TO_DEVICE_LINK = 'could-not-update-patient-to-device-link',
  COULD_NOT_UNLINK_PATIENT_TO_DEVICE = 'could-not-unlink-patient-to-device',
  COULD_NOT_GET_PATIENT_DEVICE_LINK = 'could-not-get-patient-device-link',
  COULD_NOT_GET_LINKED_PATIENTS = 'could-not-get-linked-patients',
  COULD_NOT_GET_PATIENT_DEVICE_LINKS = 'could-not-get-patient-device-links',
  COULD_NOT_COUNT_PATIENTS_WITH_DEVICE_LINK = 'could-not-count-patients-with-device-link',

  DEVICE_DATA_ID_IS_REQUIRED = 'device-data-id-is-required',
  MEDIA_REFERENCE_IS_REQUIRED = 'media-reference-is-required',
  COULD_NOT_VALIDATE_DEVICE_DATA = 'could-not-validate-device-data',
  COULD_NOT_UPDATE_DEVICE_DATA_SIZE = 'could-not-update-device-data-size',
  COULD_NOT_GET_DEVICE_DATA_SIZE_FOR_TENANT = 'could-not-get-device-data-size-for-tenant',
  COULD_NOT_ASSOCIATE_DEVICE_DATA = 'could-not-associate-device-data',
  COULD_NOT_DELETE_DEVICE_DATA_FOR_THRESHOLD = 'could-not-delete-device-data-for-threshold',
  COULD_NOT_GET_DEVICE_DATA_CSV_FILE = 'could-not-get-device-data-csv-file',
  COULD_NOT_GET_AGGREGATE_DEVICE_DATA_CSV_FILE = 'could-not-get-aggregate-device-data-csv-file',
  DEVICE_PROPERTY_AGGREGATION_OPTION_REQUIRED = 'device-property-aggregation-option-required',
  COULD_NOT_GET_DEVICE_DATA_COUNT = 'could-not-get-device-data-count',
  COULD_NOT_GET_MULTIPLE_AGGREGATE_DEVICE_DATA = 'could-not-get-multiple-aggregate-device-data',

  TOKEN_IS_REQUIRED = 'token-is-required',
  COULD_NOT_GET_AUTH_TOKEN = 'could-not-get-auth-token',
  COULD_NOT_CREATE_REFRESH_TOKEN = 'could-not-create-refresh-token',
  COULD_NOT_REFRESH_AUTH_TOKEN = 'could-not-refresh-auth-token',
  REFRESH_TOKEN_IS_REQUIRED = 'refresh-token-is-required',

  USER_OBSERVER_REQUIRED = 'user-observer-required',
  COULD_NOT_GET_USER_OBSERVERS = 'could-not-get-user-observers',
  USER_INVITE_IS_REQUIRED = 'user-invite-is-required',
  USER_NOT_FOUND_CREATE_GUEST_INVITE = 'user-not-found-create-guest-invite',
}
